import axios from 'axios'
import store from '../store'
import utils from './utils'
import { Message } from 'element-ui'

function handleError (error, reject, resolve) {
  if (error.response && error.response.status) {
    console.log('axios error', error.response)
    if (error.response.status === 401) {
      if (!location.href.includes('/login')) {
        setTimeout(function () {
          if (location.href.indexOf('/plat/login') === -1) {
            location.href = '/'
          }
        }, 1000)
        store.state.globalStore.token = ''
        sessionStorage.removeItem('userData')
        localStorage.removeItem('userToken')
        Message.error('您无此权限，请确认登录状态')
      } else {
        // Message.error('账号或密码错误，请确认后重试')
        // resolve({}) // 登录账号错误问题由页面自己去做处理
      }
    } else {
      Message.error('网络错误请联系管理员或稍后重试')
    }
    reject(error.response.data ? error.response.data : { message: '未知错误' })
  } else {
    Message.error('网络错误请联系管理员或稍后重试')
    reject(null)
  }
}

const backend = {
  development: '', // https://api-test-phei.e-ai-edu.com
  production: 'https://api-phei.e-ai-edu.com',
  testing: 'https://api-test-phei.e-ai-edu.com'
}[process.env.NODE_ENV || 'development']

// axios.defaults.withCredentials = true // 配置为true
axios.interceptors.request.use(config => {
  if (!config.disableLoading) {
    utils.showLoading()
  }
  config.headers.token = store.state.globalStore.token || localStorage.getItem('userToken')
  if (process.env.NODE_ENV !== 'development' && config.url.startsWith('/api')) {
    config.url = config.url.replace(/^\/api/, '')
  }
  if (config.url.startsWith('/')) {
    const host = backend.endsWith('/') ? backend.slice(0, backend.length - 1) : backend
    config.url = host + config.url
  }

  if (!config.params) {
    config.params = {}
  }

  //   if (method === 'post') {
  //     config.params = { ...rest, ...config.params }
  //     config.data = { ...rest, ...config.data }
  //   } else {
  //     config.params = { ...rest, ...config.params }
  //   }

  return config
}, Promise.reject)

axios.interceptors.response.use(
  res => {
    // if (res.status !== 200 || (res.data.code && res.data.message)) {
    //   uni.showToast({
    //     title: `服务器返回错误:${(res.status === 200 && res.data.message) ||
    //       res.data ||
    //       ''}`,
    //     icon: 'none'
    //   })
    //   return Promise.reject(res.data)
    // }
    if (!res.config.disableLoading) {
      utils.hideLoading()
    }
    return res.data
  },
  err => {
    utils.hideLoading()
    handleError(err, Promise.reject, Promise.resolve)
    // return Promise.resolve({
    //   message: err.response.data.message,
    //   code: err.response.data.err_code
    // })
  }
)

export default axios



// WEBPACK FOOTER //
// ./src/utils/axios.js